<template>
  <div>
    <ModuleTitle>{{ $t('jiao-se-xing-xiang-gou-cheng') }}</ModuleTitle>
    <ImageM v-bind="props" class="m-only" />
    <ImagePc v-bind="props" class="pc-only" />
  </div>
</template>
<script lang="ts" setup>
import ModuleTitle from '../module-title.vue'
import ImageM from './images-m.vue'
import ImagePc from './images-pc.vue'
import type { Character, CharacterXihe } from '~/api/interface/character'

interface ImageCompositionProps {
  character?: Character | null
  characterXihe?: CharacterXihe
}

const props = defineProps<ImageCompositionProps>()
</script>
<style lang="scss" scoped>
.image-composition-content {
  @apply mt-[46px] sm:px-[20px] grid grid-cols-5 sm:grid-cols-2 gap-[20px] w-[1200px] sm:w-full mx-auto relative;
  grid-auto-rows: 224px;
  @media (max-width: 680px) {
    grid-auto-rows: vw(165);
  }
}

.image-card {
  @apply rounded-[8px] p-[12px] relative;
  border: 1px solid var(--back-4);
  grid-column: span 1;
  grid-row: span 1;
  transition: all 0.3s ease;
  order: 2;

  &.active {
    grid-column: span 2;
    grid-row: span 2;
    .edit-btn {
      display: block;
    }
  }

  &.default-card {
    @apply sm:order-1;
  }

  &:hover .edit-btn {
    display: block;
  }

  .edit-btn {
    display: none;
    // @media (min-width: 681px) {
    // display: block;
    // }
  }
}
</style>
